import {
  Box,
  Center,
  Heading,
  HStack,
  Skeleton,
  SkeletonCircle,
  SkeletonText,
  Text,
  useColorModeValue,
  VStack,
} from "@chakra-ui/react";

/**
 * StepAnalyzing Component
 * Shown immediately after upload while the mock service "reads" the file.
 */
export default function StepAnalyzing() {
  const borderColor = useColorModeValue("gray.100", "gray.700");

  return (
    <VStack spacing={8} py={4} align="stretch">
      <Box textAlign="center">
        <Heading size="md" color="gray.800" mb={1}>
          Analyzing File...
        </Heading>
        <Text color="gray.500" fontSize="sm">
          Identifying columns and data formats
        </Text>
      </Box>

      {/* The "Scanning" Simulation Card */}
      <Box
        p={6}
        border="1px solid"
        borderColor={borderColor}
        borderRadius="xl"
        position="relative"
        overflow="hidden"
      >
        {/* Animated Scanning Line */}
        <Box
          position="absolute"
          top={0}
          left={0}
          right={0}
          h="2px"
          bgGradient="linear(to-r, transparent, blue.400, transparent)"
          boxShadow="0 0 8px blue.400"
          zIndex={2}
          animation="scan 2s ease-in-out infinite"
        />
        <style>
          {`
            @keyframes scan {
              0% { top: 0%; opacity: 0; }
              10% { opacity: 1; }
              90% { opacity: 1; }
              100% { top: 100%; opacity: 0; }
            }
          `}
        </style>

        {/* Skeleton UI representing the "Detected" data */}
        <VStack align="stretch" spacing={6}>
          <HStack spacing={4} justify="space-between">
            <VStack align="start" flex={1}>
              <Skeleton height="12px" width="40%" mb={2} />
              <Skeleton height="24px" width="80%" borderRadius="md" />
            </VStack>
            <Center flexDirection="column">
              <SkeletonCircle size="10" />
              <Skeleton height="8px" width="40px" mt={2} />
            </Center>
          </HStack>

          <Box pt={4}>
            <SkeletonText noOfLines={4} spacing="4" skeletonHeight="2" />
          </Box>
        </VStack>
      </Box>

      <HStack justify="center" spacing={2}>
        <Text fontSize="xs" color="gray.400" fontStyle="italic">
          Scanning headers...
        </Text>
      </HStack>
    </VStack>
  );
}
